"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotlightCarousel = exports.CustomLandingPage = exports.DefaultCatalogGroupPage = exports.default = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _react = _interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _base = _interopRequireWildcard(require("block/base"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _CatalogGroupPage = require("CatalogGroupPage");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _class3, _descriptor9, _class5, _descriptor10, _dec, _dec2, _class7, _descriptor11, _descriptor12, _descriptor13;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || babelHelpers.typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = babelHelpers.getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = babelHelpers.getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return babelHelpers.possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var CatalogGroup = (_dec = (0, _decorators.alias)("content.type"), _dec2 = (0, _decorators.alias)("content.name"), (_class7 = /*#__PURE__*/function (_Component4) {
  babelHelpers.inherits(CatalogGroup, _Component4);

  var _super4 = _createSuper(CatalogGroup);

  function CatalogGroup() {
    var _this4;

    babelHelpers.classCallCheck(this, CatalogGroup);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this4 = _super4.call.apply(_super4, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this4, "content", _descriptor11, babelHelpers.assertThisInitialized(_this4));
    babelHelpers.initializerDefineProperty(_this4, "type", _descriptor12, babelHelpers.assertThisInitialized(_this4));
    babelHelpers.initializerDefineProperty(_this4, "name", _descriptor13, babelHelpers.assertThisInitialized(_this4));
    return _this4;
  }

  babelHelpers.createClass(CatalogGroup, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(require(this.type)[this.name || 'default'], this.content);
    }
  }]);
  return CatalogGroup;
}(_react.Component), (_descriptor11 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "name", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class7));
exports.default = CatalogGroup;
var DefaultCatalogGroupPage = (_class = /*#__PURE__*/function (_Component) {
  babelHelpers.inherits(DefaultCatalogGroupPage, _Component);

  var _super = _createSuper(DefaultCatalogGroupPage);

  function DefaultCatalogGroupPage() {
    var _this;

    babelHelpers.classCallCheck(this, DefaultCatalogGroupPage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this, "id", _descriptor, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "background", _descriptor2, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "subHeadline", _descriptor3, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "headline", _descriptor4, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "summary", _descriptor5, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "footerBlocks", _descriptor6, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "spotlight", _descriptor7, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "catalogGroup", _descriptor8, babelHelpers.assertThisInitialized(_this));
    return _this;
  }

  babelHelpers.createClass(DefaultCatalogGroupPage, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "page-content-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _classList.default.join('block', 'stack', 'header-block', this.background && 'variable-background'),
        "data-landing-page-group": this.id,
        "data-block-type": "header",
        style: this.background ? _base.default.styleForBackgroundObject(this.background) : {}
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "spotlight-header"
      }, this.spotlight && /*#__PURE__*/_react.default.createElement(SpotlightCarousel, this.spotlight), /*#__PURE__*/_react.default.createElement("div", {
        className: "inner-content animate-fadeIn"
      }, /*#__PURE__*/_react.default.createElement("h1", {
        className: "title"
      }, this.headline), this.summary && /*#__PURE__*/_react.default.createElement("h2", null, /*#__PURE__*/_react.default.createElement(SummaryValue, {
        value: this.summary
      }))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "block stack height-auto"
      }, /*#__PURE__*/_react.default.createElement("div", {
        id: "catalogGroupPage"
      }, /*#__PURE__*/_react.default.createElement(_CatalogGroupPage.CatalogGroupPage, _extends({
        className: "stack catalog-group"
      }, this.catalogGroup)))), /*#__PURE__*/_react.default.createElement(require(this.footerBlocks.child_type).default, this.footerBlocks));
    }
  }]);
  return DefaultCatalogGroupPage;
}(_react.Component), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "background", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "subHeadline", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "headline", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "summary", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "footerBlocks", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "spotlight", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "catalogGroup", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.DefaultCatalogGroupPage = DefaultCatalogGroupPage;
var CustomLandingPage = (_class3 = /*#__PURE__*/function (_Component2) {
  babelHelpers.inherits(CustomLandingPage, _Component2);

  var _super2 = _createSuper(CustomLandingPage);

  function CustomLandingPage() {
    var _this2;

    babelHelpers.classCallCheck(this, CustomLandingPage);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this2, "content", _descriptor9, babelHelpers.assertThisInitialized(_this2));
    return _this2;
  }

  babelHelpers.createClass(CustomLandingPage, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(require(this.content.child_type).default, this.content);
    }
  }]);
  return CustomLandingPage;
}(_react.Component), (_descriptor9 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
exports.CustomLandingPage = CustomLandingPage;
var SpotlightCarousel = (_class5 = /*#__PURE__*/function (_Component3) {
  babelHelpers.inherits(SpotlightCarousel, _Component3);

  var _super3 = _createSuper(SpotlightCarousel);

  function SpotlightCarousel() {
    var _this3;

    babelHelpers.classCallCheck(this, SpotlightCarousel);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this3, "spotlightBlock", _descriptor10, babelHelpers.assertThisInitialized(_this3));
    return _this3;
  }

  babelHelpers.createClass(SpotlightCarousel, [{
    key: "render",
    value: function render() {
      if (this.spotlightBlock) return /*#__PURE__*/_react.default.createElement(require("block/spotlightGroup").default, this.spotlightBlock);
      return null;
    }
  }]);
  return SpotlightCarousel;
}(_react.Component), (_descriptor10 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "spotlightBlock", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class5);
exports.SpotlightCarousel = SpotlightCarousel;

function SummaryValue(_ref) {
  var value = _ref.value;
  if (typeof value == 'string') return value;
  return value.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: index
    }, index > 0 ? ' / ' : '', /*#__PURE__*/_react.default.createElement("a", {
      href: item.link
    }, item.title));
  });
}